[
    {"alias":"ProgmaticLogo","src":"./assets/img/preloader/ProgmaticLogo.png"},
    {"alias":"ReelsMask","src":"./assets/img/main/ReelsMask.png"},
    {"alias":"NoButtonDefault","src":"./assets/img/main/NoButtonDefault.png"},
    {"alias":"RightArrowButtonDefault","src":"./assets/img/main/RightArrowButtonDefault.png"},
    {"alias":"LeftArrowButtonDefault","src":"./assets/img/main/LeftArrowButtonDefault.png"},
    {"alias":"SettingsButtonDefault","src":"./assets/img/main/SettingsButtonDefault.png"},
    {"alias":"s_menu_settings","src":"./assets/img/main/s_menu_settings.png"},
    {"alias":"DotsOn","src":"./assets/img/main/DotsOn.png"},
    {"alias":"RectangleOff","src":"./assets/img/main/RectangleOff.png"},
    {"alias":"SettingsSliderBg","src":"./assets/img/main/SettingsSliderBg.png"},
    {"alias":"SoundOn","src":"./assets/img/main/SoundOn.png"},
    {"alias":"ToggleOn","src":"./assets/img/main/ToggleOn.png"},
    {"alias":"DotsOff","src":"./assets/img/main/DotsOff.png"},
    {"alias":"RectangleOn","src":"./assets/img/main/RectangleOn.png"},
    {"alias":"SoundOff","src":"./assets/img/main/SoundOff.png"},
    {"alias":"ToggleOff","src":"./assets/img/main/ToggleOff.png"},
    {"alias":"ConfirmButtonDefault","src":"./assets/img/main/ConfirmButtonDefault.png"},
    {"alias":"PlayButtonDefault","src":"./assets/img/main/PlayButtonDefault.png"},
    {"alias":"SwitchOn","src":"./assets/img/main/SwitchOn.png"},
    {"alias":"SwitchOff","src":"./assets/img/main/SwitchOff.png"},
    {"alias":"HomeIcon","src":"./assets/img/main/HomeIcon.png"},
    {"alias":"LinkIcon","src":"./assets/img/main/LinkIcon.png"},
    {"alias":"s_game_logo_portrait 1","src":"./assets/img/main/s_game_logo_portrait 1.png"},
    {"alias":"s_game_logo 1","src":"./assets/img/main/s_game_logo 1.png"},
    {"alias":"PopupBG","src":"./assets/img/main/PopupBG.png"},
    {"alias":"S1","src":"./assets/img/main/S1.png"},
    {"alias":"S2","src":"./assets/img/main/S2.png"},
    {"alias":"S3","src":"./assets/img/main/S3.png"},
    {"alias":"S4","src":"./assets/img/main/S4.png"},
    {"alias":"S5","src":"./assets/img/main/S5.png"},
    {"alias":"S6","src":"./assets/img/main/S6.png"},
    {"alias":"S7","src":"./assets/img/main/S7.png"},
    {"alias":"S8","src":"./assets/img/main/S8.png"},
    {"alias":"S9","src":"./assets/img/main/S9.png"},
    {"alias":"S10","src":"./assets/img/main/S10.png"},
    {"alias":"S11","src":"./assets/img/main/S11.png"},
    {"alias":"IntroLandscapBG","src":"./assets/img/main/IntroLandscapBG.png"},
    {"alias":"IntroPortraitBG","src":"./assets/img/main/IntroPortraitBG.png"},
    {"alias":"s_reels_frame_top 1","src":"./assets/img/main/s_reels_frame_top 1.png"},
    {"alias":"s_volatility_box","src":"./assets/img/main/s_volatility_box.png"},
    {"alias":"s_lightning_enabled","src":"./assets/img/main/s_lightning_enabled.png"},
    {"alias":"s_lightning_disabled","src":"./assets/img/main/s_lightning_disabled.png"},
    {"alias":"ReelsFsBg","src":"./assets/img/main/ReelsFsBg.png"},
    {"alias":"ReelsBg","src":"./assets/img/main/ReelsBg.png"},
    {"alias":"Volatility","src":"./assets/img/main/Volatility.png"},
    {"alias":"s_button_buyfeature_normal","src":"./assets/img/main/s_button_buyfeature_normal.png"},
    {"alias":"s_button_betLevel_ON","src":"./assets/img/main/s_button_betLevel_ON.png"},
    {"alias":"s_button_betLevel_OFF","src":"./assets/img/main/s_button_betLevel_OFF.png"},
    {"alias":"s_gameWindow_star","src":"./assets/img/main/s_gameWindow_star.png"},
    {"alias":"s_gameWindow_candy","src":"./assets/img/main/s_gameWindow_candy.png"},
    {"alias":"s_Spin_Normal","src":"./assets/img/main/s_Spin_Normal.png"},
    {"alias":"s_Spin_Start_Icon","src":"./assets/img/main/s_Spin_Start_Icon.png"},
    {"alias":"Stop","src":"./assets/img/main/Stop.png"},
    {"alias":"s_Sound","src":"./assets/img/main/s_Sound.png"},
    {"alias":"s_InfoLand","src":"./assets/img/main/s_InfoLand.png"},
    {"alias":"s_Info","src":"./assets/img/main/s_Info.png"},
    {"alias":"s_close_x","src":"./assets/img/main/s_close_x.png"},
    {"alias":"s_bet_plus","src":"./assets/img/main/s_bet_plus.png"},
    {"alias":"s_bet_minus","src":"./assets/img/main/s_bet_minus.png"},
    {"alias":"InfoButtonDefault","src":"./assets/img/main/InfoButtonDefault.png"},
    {"alias":"ClosButtonDefault","src":"./assets/img/main/ClosButtonDefault.png"},
    {"alias":"MinusButtonDefault","src":"./assets/img/main/MinusButtonDefault.png"},
    {"alias":"PlusButtonDefault","src":"./assets/img/main/PlusButtonDefault.png"},
    {"alias":"MenuBtn","src":"./assets/img/main/MenuBtn.png"},
    {"alias":"SpinControlsBG","src":"./assets/img/main/SpinControlsBG.png"},
    {"alias":"AutoBtn","src":"./assets/img/main/AutoBtn.png"},
    {"alias":"s_CombinedLeft3","src":"./assets/img/main/s_CombinedLeft3.png"},
    {"alias":"s_CombinedLeft2","src":"./assets/img/main/s_CombinedLeft2.png"},
    {"alias":"s_CombinedLeft1","src":"./assets/img/main/s_CombinedLeft1.png"},
    {"alias":"s_Menu","src":"./assets/img/main/s_Menu.png"},
    {"alias":"s_MenuLand","src":"./assets/img/main/s_MenuLand.png"},
    {"alias":"spin_mobile","src":"./assets/img/main/spin_mobile.png"},
    {"alias":"AutoplayButtonImg","src":"./assets/img/main/AutoplayButtonImg.png"},
    {"alias":"s_button_buyfeature_normal_portrait","src":"./assets/img/main/s_button_buyfeature_normal_portrait.png"},
    {"alias":"TurboSpinPortrait","src":"./assets/img/main/TurboSpinPortrait.png"},
    {"alias":"TurboSpinIcon","src":"./assets/img/main/TurboSpinIcon.png"},
    {"alias":"QuickPortrait","src":"./assets/img/main/QuickPortrait.png"},
    {"alias":"QuickSpinIcon","src":"./assets/img/main/QuickSpinIcon.png"},
    {"alias":"NormalSpinPortrait","src":"./assets/img/main/NormalSpinPortrait.png"},
    {"alias":"NormalSpinIcon","src":"./assets/img/main/NormalSpinIcon.png"},
    {"alias":"s_RightArrow","src":"./assets/img/main/s_RightArrow.png"},
    {"alias":"BetPortaitButton","src":"./assets/img/main/BetPortaitButton.png"},
    {"alias":"AutoplayPortaitButton","src":"./assets/img/main/AutoplayPortaitButton.png"},
    {"alias":"s_button_betLevel_ON_portrait","src":"./assets/img/main/s_button_betLevel_ON_portrait.png"},
    {"alias":"s_button_betLevel_OFF_portrait","src":"./assets/img/main/s_button_betLevel_OFF_portrait.png"},
    {"alias":"s_RightArrowSmall","src":"./assets/img/main/s_RightArrowSmall.png"},
    {"alias":"s_MiddleArrowSmall","src":"./assets/img/main/s_MiddleArrowSmall.png"},
    {"alias":"s_MiddleArrow","src":"./assets/img/main/s_MiddleArrow.png"},
    {"alias":"BetMenuBG","src":"./assets/img/main/BetMenuBG.png"},
    {"alias":"BottomPanelBackground","src":"./assets/img/main/BottomPanelBackground.png"},
    {"alias":"SliderBtn","src":"./assets/img/main/SliderBtn.png"},
    {"alias":"T_on","src":"./assets/img/main/T_on.png"},
    {"alias":"BoxOn","src":"./assets/img/main/BoxOn.png"},
    {"alias":"BoxOff","src":"./assets/img/main/BoxOff.png"},
    {"alias":"s_x","src":"./assets/img/main/s_x.png"},
    {"alias":"AutBG","src":"./assets/img/main/AutBG.png"},
    {"alias":"T_off","src":"./assets/img/main/T_off.png"},
    {"alias":"s_PaytablePageButton_Right_Normal","src":"./assets/img/main/s_PaytablePageButton_Right_Normal.png"},
    {"alias":"s_PaytablePageButton_Left_Normal","src":"./assets/img/main/s_PaytablePageButton_Left_Normal.png"},
    {"alias":"s_PaytablePageButton_Close_Normal","src":"./assets/img/main/s_PaytablePageButton_Close_Normal.png"},
    {"alias":"BG_Multiplier","src":"./assets/img/main/BG_Multiplier.png"},
    {"alias":"s_paytable_GUI_speed2 1","src":"./assets/img/main/s_paytable_GUI_speed2 1.png"},
    {"alias":"AutoplayLandscapeBtn","src":"./assets/img/main/AutoplayLandscapeBtn.png"},
    {"alias":"BetLandBtn","src":"./assets/img/main/BetLandBtn.png"},
    {"alias":"NormalSpinLand","src":"./assets/img/main/NormalSpinLand.png"},
    {"alias":"QuickLand","src":"./assets/img/main/QuickLand.png"},
    {"alias":"TurboSpinLand","src":"./assets/img/main/TurboSpinLand.png"},
    {"alias":"s_Decrement","src":"./assets/img/main/s_Decrement.png"},
    {"alias":"s_Increment","src":"./assets/img/main/s_Increment.png"},
    {"alias":"stop_spin_mobile","src":"./assets/img/main/stop_spin_mobile.png"},
    {"alias":"FSRetriggerPopupBG","src":"./assets/img/main/FSRetriggerPopupBG.png"},
    {"alias":"SoundsIcon50","src":"./assets/img/main/SoundsIcon50.png"},
    {"alias":"SoundsIcon25","src":"./assets/img/main/SoundsIcon25.png"},
    {"alias":"SoundsIcon0","src":"./assets/img/main/SoundsIcon0.png"},
    {"alias":"SoundsIcon100","src":"./assets/img/main/SoundsIcon100.png"},
    {"alias":"SOff","src":"./assets/img/main/SOff.png"}
]